import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';

export default function CheckoutCancel() {
  return (
    <Layout>
      <section className="section-padding bg-slate-50 min-h-screen flex items-center" data-testid="checkout-cancel">
        <div className="container-custom">
          <div className="max-w-lg mx-auto text-center">
            <div className="bg-white rounded-2xl p-10 border border-slate-200">
              <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-slate-400" />
              </div>
              <h1 className="font-heading text-2xl font-bold text-navy mb-3">
                Checkout Cancelled
              </h1>
              <p className="text-slate-600 mb-6">
                Your payment was cancelled and you have not been charged. 
                You can try again whenever you're ready.
              </p>
              
              <div className="space-y-3">
                <Link
                  to="/checkout"
                  className="w-full btn-copper flex items-center justify-center gap-2"
                  data-testid="try-again-btn"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Return to Checkout
                </Link>
                <Link
                  to="/"
                  className="w-full btn-primary flex items-center justify-center gap-2"
                >
                  Go to Homepage
                </Link>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-200">
                <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
                  <HelpCircle className="w-4 h-4" />
                  <span>Need help? <a href="mailto:hello@bevrelay.com" className="text-copper hover:underline">Contact support</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
